import React, { RefObject } from 'react';
import { ColourTheme } from '../../../../types/ColourTheme';
import { NewVideoPlayer } from '../../../common/NewVideoPlayer/NewVideoPlayer';
import { personaToVidImg, personaToVidLink } from './PersonaVideoImageMap';
import './PersonaVideo.scss';

type Props = {
  theme: ColourTheme;
  refProps: RefObject<HTMLDivElement>;
};

export const PersonaVideo = (props: Props) => {
  return (
    <div className="PersonaVideo" ref={props.refProps}>
      <NewVideoPlayer
        imgSrc={personaToVidImg[props.theme]}
        videoSrc={`https://youtu.be/${personaToVidLink[props.theme]}`}
        textColor="white"
        autoplay={true}
      />
    </div>
  );
};
